import { render } from "./Dashboard1.vue?vue&type=template&id=131e2696&scoped=true"
import script from "./Dashboard1.vue?vue&type=script&lang=js"
export * from "./Dashboard1.vue?vue&type=script&lang=js"

import "./Dashboard1.vue?vue&type=style&index=0&id=131e2696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131e2696"]])

export default __exports__